import { supabase } from '@/lib/supabase';

/**
 * The public URL of the gym's logo. `branding` is the only public bucket (CLAUDE.md
 * "Storage paths are access rules"), so no signed URL and no request are needed.
 */
export function useGymLogoUrl(logoPath: string | null): string | null {
  if (!logoPath) return null;
  return supabase.storage.from('branding').getPublicUrl(logoPath).data.publicUrl;
}
